import React, { useEffect, useState , useContext} from "react";
import api from "./api";
import { AuthContext } from "./auth/AuthContext";
import { SubscribeContext } from "./SubscribeContext";
function Home({ onSubscribeClick }) {
  const { openSubscribe } = useContext(SubscribeContext);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [brands, setBrands] = useState([]);
  const { user, setUser } = useContext(AuthContext);
  const [popularCategories, setPopularCategories] = useState([]);
  const [homeData, sethomeData] = useState(null);
  // for construction popup
  const [showConstructionPopup, setShowConstructionPopup] = useState(true);
  const accountLink = user ? "/update-profile" : "/login";
  const ordersLink  = user ? "/orders" : "/login";
  const quoteLink   = user ? "/my-quotes" : "/login";
  const returnLink  = user ? "/orders" : "/login";
  const getSafeColor = (code) => {
  if (!code) return "#cccccc";

  const c = code.trim();

  // valid hex
  if (/^#([0-9A-F]{3}){1,2}$/i.test(c)) return c;

  // rgb/rgba support
  if (c.startsWith("rgb")) return c;

  return "#cccccc";
};
  useEffect(() => {
    api.get("/api/featured-products").then(res => setFeaturedProducts(res.data));
    api.get("/api/popular-brands").then(res => setBrands(res.data));
    api.get("/api/popular-categories").then(res => setPopularCategories(res.data)); 
    api.get("/api/homepage-data").then(res => sethomeData(res.data)); 
    
    // ✅ HERO SLIDER SCRIPT
  const slides = Array.from(document.querySelectorAll('.hero-slide'));
  const dots   = Array.from(document.querySelectorAll('.hero-dot'));
  const prev   = document.querySelector('.hero-arrow[aria-label="Previous slide"]');
  const next   = document.querySelector('.hero-arrow[aria-label="Next slide"]');
 
  if(!slides.length) return;

  let current = Math.max(0, slides.findIndex(s => s.classList.contains('is-active')));
  if(current < 0) current = 0;

  const update = () => {
    slides.forEach((s,i)=> s.classList.toggle('is-active', i === current));
    dots.forEach((d,i)=> d.classList.toggle('is-active', i === current));
    if(prev) prev.disabled = current === 0;
    if(next) next.disabled = current === slides.length - 1;
  };

  const go = (delta) => {
    const nextIndex = current + delta;
    if(nextIndex < 0 || nextIndex >= slides.length) return;
    current = nextIndex;
    update();
  };

  dots.forEach((dot,i)=>{ 
    dot.addEventListener('click', ()=>{ current = i; update(); }); 
  });

  if(prev) prev.addEventListener('click', ()=> go(-1));
  if(next) next.addEventListener('click', ()=> go(1));

  update();

  }, []);
  
  return (
    <>
      {/* ===================== UNDER CONSTRUCTION POPUP ===================== */}
      {showConstructionPopup && (
        <div className="construction-overlay">
          <div className="construction-popup">
            
            <button
              type="button"
              className="construction-close"
              onClick={() => setShowConstructionPopup(false)}
              aria-label="Close"
            >
              ×
            </button>

            <div className="construction-icon">
              ⚠
            </div>

            <h2>Website Still Under Development</h2>

            <p>
              You can browse products, but pricing and inventory may not be
              up to date yet, so please do not attempt to purchase.
            </p>

            <button
              type="button"
              className="construction-ok"
              onClick={() => setShowConstructionPopup(false)}
            >
              Continue Browsing
            </button>

          </div>
        </div>
      )}

      {/* ===================== NEW HTML DESIGN START ===================== */}

      <div className="hero-carousel" aria-label="Hero slides">
        <section className="hero card-primary hero-slide hero-primary is-active" data-slide-type="primary" data-slide-index="0">
          <div className="hero-grid">
            <div className="hero-copy">
               {homeData?.banner1headerpill?.text && (
                  <div className="hero-badge">
                    {homeData.banner1headerpill.text}
                  </div>
                )}
              <h1 className="hero-title">{homeData?.banner1heading?.text}</h1>
              <p className="hero-subtitle">{homeData?.banner1text?.text}</p>
              <div className="hero-stat-row">
               {homeData?.banner1pilltext1?.text && <span className="hero-stat">{homeData?.banner1pilltext1?.text}</span>}
               {homeData?.banner1pilltext2?.text && <span className="hero-stat">{homeData?.banner1pilltext2?.text}</span>}
              </div>
             <div className="hero-actions">

              {homeData?.banner1button1?.text && (
                <a
                  className="btn-primary"
                  href={homeData?.banner1button1?.buttonurl || "#"}
                >
                  {homeData.banner1button1.text}
                </a>
              )}

              {homeData?.banner1button2?.text && (
                <a
                  className="hero-link"
                  href={homeData?.banner1button2?.buttonurl || "#"}
                >
                  {homeData.banner1button2.text}
                </a>
              )}

            </div>
            </div>
            
            <div className="hero-visual sale-banner"
              style={{
                  backgroundImage: `url(${
                    homeData?.banner1_image?.image ||
                    "https://source.unsplash.com/1200x800/?workwear,safety,gear"
                  })`
                }}
                aria-hidden="true">
              {/* <div className="hero-visual-label">Built For Fast First Orders</div> */}
            </div>
          </div>
        </section>
        <section className="hero card-primary hero-slide hero-promo" data-slide-type="promo" data-slide-index="1">
          <div className="hero-grid">
            <div className="hero-copy">
               {homeData?.banner2headerpill?.text && (
                  <div className="hero-badge">
                    {homeData.banner2headerpill.text}
                  </div>
                )}
              <h1 className="hero-title">{homeData?.banner2heading?.text}</h1>
              <p className="hero-subtitle">{homeData?.banner2text?.text}</p>
              <div className="hero-stat-row">
                {homeData?.banner2pilltext1?.text && <span className="hero-stat">{homeData?.banner2pilltext1?.text}</span>}
                {homeData?.banner2pilltext2?.text && <span className="hero-stat">{homeData?.banner2pilltext2?.text}</span>}
              </div>
              <div className="hero-actions">

                {homeData?.banner2button1?.text && (
                  <a
                    className="btn-primary"
                    href={homeData?.banner2button1?.buttonurl || "#"}
                  >
                    {homeData.banner2button1.text}
                  </a>
                )}

                {homeData?.banner2button2?.text && (
                  <a
                    className="hero-link"
                    href={homeData?.banner2button2?.buttonurl || "#"}
                  >
                    {homeData.banner2button2.text}
                  </a>
                )}

              </div>
            </div>
             <div className="hero-visual custom-banner"
              style={{ backgroundImage: `url('${
                      homeData?.banner2_image?.image
                        ? homeData.banner2_image.image
                        : "https://source.unsplash.com/1200x800/?workwear,safety,gear"
                    }')`
                }}
                aria-hidden="true"
              >
              {/* <div className="hero-visual-label">Brand-Ready Uniform Programs</div> */}
            </div>
          </div>
        </section>
        <section className="hero card-primary hero-slide hero-promo" data-slide-type="promo" data-slide-index="2">
          <div className="hero-grid">
            <div className="hero-copy">
              {homeData?.banner3headerpill?.text && (
                <div className="hero-badge">
                  {homeData.banner3headerpill.text}
                </div>
              )}
              <h1 className="hero-title">{homeData?.banner3heading?.text}</h1>
              <p className="hero-subtitle">{homeData?.banner3text?.text}</p>
              <div className="hero-stat-row">
                {homeData?.banner3pilltext1?.text && <span className="hero-stat">{homeData?.banner3pilltext1?.text}</span>}
                {homeData?.banner3pilltext2?.text && <span className="hero-stat">{homeData?.banner3pilltext2?.text}</span>}
              </div>
              <div className="hero-actions">

                {homeData?.banner3button1?.text && (
                  <a
                    className="btn-primary"
                    href={homeData?.banner3button1?.buttonurl || "#"}
                  >
                    {homeData.banner3button1.text}
                  </a>
                )}

                {homeData?.banner3button2?.text && (
                  <a
                    className="hero-link"
                    href={homeData?.banner3button2?.buttonurl || "#"}
                  >
                    {homeData.banner3button2.text}
                  </a>
                )}

              </div>
            </div>
            
              <div className="hero-visual reorder-banner"
              style={{ backgroundImage: `url('${
                      homeData?.banner3_image?.image
                        ? homeData.banner3_image.image
                        : "https://source.unsplash.com/1200x800/?workwear,safety,gear"
                    }')`
                }}
                aria-hidden="true"
              >
              {/* <div className="hero-visual-label">Fast Repeat Orders, Fewer Mistakes</div> */}
            </div>
          </div>
        </section>
        <div className="hero-controls" aria-hidden="true">
          <button className="hero-arrow" type="button" aria-label="Previous slide" disabled><svg className="hero-arrow-icon" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M11.5 5.5L7 10l4.5 4.5" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"/></svg></button>
          <div className="hero-nav">
            <span className="hero-dot is-active" data-slide-index="0"></span>
            <span className="hero-dot" data-slide-index="1"></span>
            <span className="hero-dot" data-slide-index="2"></span>
          </div>
          <button className="hero-arrow" type="button" aria-label="Next slide" disabled><svg className="hero-arrow-icon" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M8.5 5.5L13 10l-4.5 4.5" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"/></svg></button>
        </div>
      </div>
      
      <section className="subscription">
        <div className="subscription-bar" role="presentation">
          <div className="subscription-icon" aria-hidden="true">10%</div>
          <div className="subscription-copy">
            <strong>Subscribe & Save 10% on Your First Order!</strong>
            <span>Your 10% discount is applied automatically at checkout—no promo code required.</span>
          </div>
         <a  className="btn-outline" onClick={() => {
                  console.log("Subscribe clicked");
                  openSubscribe();
                }}>
                Subscribe
              </a>
        </div>
      </section>
      {/* <section className="trust-strip">
        <div className="trust-grid">
          <div className="trust-item">
            <span className="trust-kicker">Built For Repeat Buyers</span>
            <span className="trust-copy">Account tools, saved lists, and order history reduce repeat-order friction.</span>
          </div>
          <div className="trust-item">
            <span className="trust-kicker">Bulk &amp; Imprinting Ready</span>
            <span className="trust-copy">Support for crew outfitting, branding, and quantity-based ordering from the start.</span>
          </div>
          <div className="trust-item">
            <span className="trust-kicker">Popular Jobsite Categories</span>
            <span className="trust-copy">Hi-vis, gloves, eyewear, PPE, and everyday essentials are easy to find fast.</span>
          </div>
          <div className="trust-item">
            <span className="trust-kicker">Fast Reorder Workflow</span>
            <span className="trust-copy">Return to approved gear without rebuilding the same order every time.</span>
          </div>
        </div>
      </section> */}

      {/* ---------------- WEEKLY DEALS SECTION (DYNAMIC) ---------------- */}
      <section className="section weekly-deals section-soft" style={{ borderTop: "4px solid rgba(0,18,31,0.10)" }}>
          <div className="section-header">
            <h2 className="section-title">Weekly Deals</h2>
            <a href="/weekly-deals" className="section-link">Shop All Deals</a>
          </div>
          <div className="weekly-panel">
            <div className="weekly-deals-grid">
            
              {featuredProducts.map((product) => (
                        <article key={product.id} className="card-utility weekly-deal-card">
                          <a className="weekly-deal-link" href={`/products/${product.id}/${encodeURIComponent(product.name)}`}>
                            <div className="weekly-deal-image" style={{ backgroundImage: `url(${product.frontimage})` }}>
                           
                           {(() => {
                              const text = (
                                (product.description || "") + " " + (product.name || "")
                              ).toLowerCase();

                              // Ensure ANSI context exists
                              if (!text.includes("ansi")) return null;

                              // Find ALL "Class X"
                              const classMatches = [...text.matchAll(/class\s*(\d)/gi)];
                              const classes = [...new Set(classMatches.map(m => m[1]))];

                              if (classes.length) {
                                return (
                                  <span className="wg-plp-feature-badge">
                                    ANSI Class {classes.join(" / ")}
                                  </span>
                                );
                              }

                              return null;
                            })()}
                                </div>
                            <div className="weekly-deal-content">
                              <span className="weekly-brand">{product.Brand}</span>
                              <h3 className="card-title">{product.name}</h3>
                              <div className="weekly-price"><span className="current">${Number(product.salePrice || 0).toFixed(2)}</span>
                                  {Number(product.customerPrice) !== 0 && (
                                        <span className="old">
                                          ${Number(product.customerPrice).toFixed(2)}
                                        </span>
                                  )}
                              </div>
                              <div className="weekly-swatches" aria-label="Available colors">
                                {product.colors?.map((c, i) => {
                                  const bg = getSafeColor(c.color_code);

                                  return (
                                    <span
                                      key={i}
                                      className="weekly-swatch"
                                      title={c.colorName}
                                      style={{
                                        background: bg,
                                        border: bg.toLowerCase() === "#ffffff" ? "1px solid #999" : "none"
                                      }}
                                    />
                                  );
                                })}

                              </div>
                              <span className="weekly-button">See Options</span>
                            </div>
                          </a>
                        </article>
                ))}
          </div>
          </div>
        </section>
     

      {/* ---------------- OTHER STATIC SECTIONS ---------------- */}
      <section className="section shop-categories section-soft" style={{ borderTop:"4px solid rgba(249, 142, 76, 0.30)"}}>
        <h2 className="section-title">Explore Popular Categories</h2>
        <div className="category-grid">

          {popularCategories.map((cat) => (
            <a
              key={cat.id}
              href={`/category/subcategory/${cat.name}`}
              className="category-tile"
            >
              <span className="category-icon">
                <img src={cat.image} alt={cat.name} />
              </span>

              <span className="category-text">
                <span className="category-label">{cat.name}</span>
                <span className="category-meta">Shop Now</span>
              </span>
            </a>
          ))}
          <a href="/weekly-deals" class="category-tile">
            <span class="category-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9">
              <path d="M20 12.5 11.5 21 3 12.5V5h7.5L20 12.5Z"></path>
              <path d="M7.5 8.5h.01"></path>
            </svg>
            </span>
            <span class="category-text"><span class="category-label">Deals</span><span class="category-meta">Weekly Specials &amp; Opening Offers</span></span>
          </a>
        </div>
      </section>

      <section className="section quick-access section-soft" style={{ borderTop: "4px solid rgba(0,18,31,0.10)" }}>
        <h2 className="section-title">Quick Access</h2>
        <div className="quick-access-grid">
          <a href={accountLink} className="card-utility quick-access-card">
            <div className="quick-access-card-inner">
              <span className="quick-icon" aria-hidden="true">
               <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.9"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ><path d="M20 21a8 8 0 0 0-16 0"/>
                 <circle cx="12" cy="8" r="4"/></svg>
                
              </span>
              <div className="quick-copy">
                <h3 className="quick-title">My Account</h3>
                <p className="quick-meta">Manage profile, settings, and saved items</p>
              </div>
            </div>
          </a>
          <a href={ordersLink} className="card-utility quick-access-card">
            <div className="quick-access-card-inner">
              <span className="quick-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 8a2 2 0 0 0-2-2h-3l-2-2H10L8 6H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2Z"/>
                  <path d="M3 10h18"/>
                </svg>
              </span>
              <div className="quick-copy">
                <h3 className="quick-title">Orders</h3>
                <p className="quick-meta">View Order History And Track Shipments</p>
              </div>
            </div>
          </a>
          <a href={returnLink} className="card-utility quick-access-card">
            <div className="quick-access-card-inner">
              <span className="quick-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 14 4 9l5-5"/>
                  <path d="M20 20v-7a4 4 0 0 0-4-4H4"/>
                </svg>
              </span>
              <div className="quick-copy">
                <h3 className="quick-title">Returns</h3>
                <p className="quick-meta">Start Or Manage A Return</p>
              </div>
            </div>
          </a>
          <a href={quoteLink} className="card-utility quick-access-card">
            <div className="quick-access-card-inner">
              <span className="quick-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20.59 13.41 11 23H4v-7.01l9.59-9.58a2 2 0 0 1 2.82 0l4.18 4.18a2 2 0 0 1 0 2.82Z"/>
                  <path d="m13 7 4 4"/>
                </svg>
              </span>
              <div className="quick-copy">
                <h3 className="quick-title">Bulk &amp; Imprinting</h3>
                <p className="quick-meta">Request Quotes And Custom Branding</p>
              </div>
            </div>
          </a>
        </div>
      </section>
      <section className="section section-soft why-us" style={{ borderTop: "4px solid rgba(249,142,76,0.38)" }}>
        <div className="why-grid">
          <div>
            <h2 className="section-title">Why WorkGear365?</h2>
            <div className="why-list">
              <div className="why-item">
                <div className="why-bullet" aria-hidden="true">↻</div>
                <div className="why-copy">
                  <h3 className="quick-title">Repeat Orders, Simplified</h3>
                  <p className="why-oneliner">Saved products, branding, and order history make reordering fast.</p>
                </div>
              </div>
              <div className="why-item">
                <div className="why-bullet" aria-hidden="true">👥</div>
                <div className="why-copy">
                  <h3 className="quick-title">Crew Buying In One Flow</h3>
                  <p className="why-oneliner">Handle team gear, size changes, and reorders without starting over.</p>
                </div>
              </div>
              <div className="why-item">
                <div className="why-bullet" aria-hidden="true">⚡</div>
                <div className="why-copy">
                  <h3 className="quick-title">Jobsite Essentials Up Front</h3>
                  <p className="why-oneliner">Hi-vis, gloves, eyewear, and PPE stay easy to find fast.</p>
                </div>
              </div>
              <div className="why-item">
                <div className="why-bullet" aria-hidden="true">✦</div>
                <div className="why-copy">
                  <h3 className="quick-title">Bulk + Imprinting Ready</h3>
                  <p className="why-oneliner">Built to support one-off buyers and branded crew orders together.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="why-visual" style={{ backgroundImage: homeData?.why_workgear?.image ? `url(${homeData.why_workgear.image})` : "url(https://source.unsplash.com/900x900/?workwear,warehouse,gear)" }} aria-hidden="true">
            <div className="why-badge">{homeData?.why_workgear?.text}</div>
          </div>
        </div>
      </section>
      {/* ---------------- POPULAR BRANDS (DYNAMIC) ---------------- */}
      <section className="section brands section-soft" style={{ borderTop: "4px solid rgba(0,18,31,0.10)" }}>
        <div className="section-header">
          <h2 className="section-title">Popular Brands</h2>
          <a href="/brands" className="section-link">Shop All Brands</a>
        </div>
        <div className="brand-carousel" aria-label="Popular Brands">
          <div className="brand-track">
            <div className="brand-group">
              {brands.map((brand) => (
              <div key={brand.brandName} className="brand-item">
                <div className="brand-pill">
                    <a href={`/products/brand/${encodeURIComponent(brand.brandName)}`}>
                       <img
                          src={brand.brand_img_url}
                          alt={brand.brandName}
                          className="img-fluid"
                          style={{ maxHeight: "80px", objectFit: "contain" }}
                          onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = "/images/workgear-logo.png";
                          }}
                        />
                      </a>
                </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    
    </>
  );
}

export default Home;